import { Product } from "../../../../sdk/@types";
import ProductService from "../../../../sdk/services/ProductService";
import { PERIODICITIES, PLANS } from "../data/catalog";
import { Plan } from "../types";
import { normalize } from "../lib/format";

class PlansRepository {
  static async getAll(): Promise<Plan[]> {
    const products = (await ProductService.getAll()) ?? [];
    const catalogByTitle = new Map(PLANS.map((plan) => [normalize(plan.name), plan]));
    return products
      .filter((p) => !p.disabled && p.title && p.id)
      .map((p) => fromProduct(p, catalogByTitle.get(normalize(p.title as string))));
  }
}

/** Product access length. A catalog row and periodicityId never supply this number. */
function productAmountOfDays(value: unknown): number | undefined {
  if (typeof value !== "number" || !Number.isFinite(value) || value <= 0) {
    return undefined;
  }
  return value;
}

export function fromProduct(p: Product.Product, fallback: Partial<Plan> = {}): Plan {
  const periodicity =
    PERIODICITIES.find((per) => per.days === p.amountOfDays)?.id ?? fallback.periodicityId ?? "mensal";
  return {
    ...fallback,
    id: p.id ?? "",
    productId: p.id,
    name: p.title ?? "",
    slug: fallback.slug ?? normalize(p.title ?? "").replace(/\s+/g, "-"),
    // Only a category the catalog already stored. An unmatched product stays unmarked.
    categoryId: fallback.categoryId,
    typeId: fallback.typeId ?? (p.mockTestId ? "simulado" : "assinatura"),
    periodicityId: periodicity,
    amountOfDays: productAmountOfDays(p.amountOfDays),
    description: p.description || fallback.description || "",
    price: p.price ?? 0,
    installment: fallback.price === p.price ? fallback.installment : undefined,
    benefits: p.features?.length ? p.features : fallback.benefits ?? [],
    icon: fallback.icon ?? "shield-check",
    accent: fallback.accent ?? "green",
    popular: p.popular,
    createdAt: p.createdAt ?? new Date().toISOString(),
  };
}

export default PlansRepository;
